// Central status constants used across Business Partner flows
// Exported as frozen objects to prevent accidental mutation

export const STATUS_PARENT_MAP = Object.freeze({
  ja_tel: 3,
  ja_vorort: 4,
  nein: 2,
  ungueltig_dublette: 9,
  ungueltig_keinanruf: 8
});

export const STATUS_END_MAP = Object.freeze({
  desinteressiert: 31,
  nie_erreicht: 27,
  geschaeftsaufgabe: 26
});

// Unified mapping for Sales Pitch status selections used in BusinessPartner
export const SALES_PITCH_STATUS_IDS = Object.freeze({
  // Step 1 (Kontakt hergestellt) base selections
  step1: Object.freeze({
    'Ja, telefonisch': 3,
    'Ja, vor Ort': 4,
    'Nein': 2,
    'Ungültig: Dublette': 9,
    'Ungültig: kein Anschluss': 8,
  }),
  // End reasons under "Beendet"
  beendet: Object.freeze({
    'Geschäftsaufgabe': 26,
    'Entscheider nie erreicht': 27,
    'Entscheider desinteressiert': 31,
  }),
  // Invalid sub-options under Kontakt hergestellt
  invalid: Object.freeze({
    'Ungültig: Dublette': 9,
    'Ungültig: kein Anschluss': 8,
  }),
  // Follow-up appointment types
  termin: Object.freeze({
    'Rückruf': 6,
    'Termin vor Ort': 7,
  }),
});
